import React from "react";
import { Button, Table } from "antd";
import { Controller, useFieldArray } from "react-hook-form";
import { useFormContext } from "./FormProvider";
import PropTypes from "prop-types";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { createStyles } from "antd-style";
import { Typography } from "antd";

const { Text } = Typography;

const useStyle = createStyles(({ css, token }) => {
  return {
    arrayFieldTable: css`
      .ant-table {
        .ant-table-cell {
          vertical-align: top;
        }
      }
    `,
  };
});

export const FormArrayField = ({
  name,
  addButtonText = "Add",
  defaultValue = {},
  inputs,
}) => {
  const { control } = useFormContext();
  const { styles } = useStyle();

  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const tableColumns = React.useMemo(() => {
    return [
      {
        title: (
          <Button
            type="dashed"
            onClick={() => append(defaultValue)}
            icon={<PlusOutlined />}
            style={{ minWidth: "60px" }}
          ></Button>
        ),
        key: "action",
        width: 60,
        render: (_, __, index) => (
          <div style={{ textAlign: "center" }}>
            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => remove(index)}
              danger
            />
          </div>
        ),
      },
      ...inputs.map((input) => ({
        title: input.props.label,
        ...input.props,
        render: (_, __, index) => {
          return React.cloneElement(input, {
            name: [name, index, input.props.name].join("."),
            labelCol: { span: 0 },
            wrapperCol: { span: 24 },
            label: null,
          });
        },
      })),
    ];
  }, [inputs, remove, name]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // console.log("formarrayfield", name, error, fields, getValues(name))
        return (
          <div>
            <Table
              className={styles.arrayFieldTable}
              dataSource={fields}
              columns={tableColumns}
              pagination={false}
              rowKey="id"
              size="middle"
            />
            {error && <Text type="danger">{error.message}</Text>}
          </div>
        );
      }}
    />
  );
};

FormArrayField.propTypes = {
  name: PropTypes.string.isRequired,
  addButtonText: PropTypes.string,
  defaultValue: PropTypes.object,
};
